import React from "react";
import { Card } from "primereact/card"; // Import Card component
import { ReactComponent as TickAfter } from "../../assets/TickAfter.svg";
import { ReactComponent as Review } from "../../assets/Review.svg";
import { ReactComponent as Technology } from "../../assets/Technology.svg";

const StartFlow = ({ registrationForm, botFlowStatus }) => {
  return (
    <div className="start-flow-container">
      <div className="start-flow-header">
        {botFlowStatus === "CLOSED" ? (
          <span>
            <Review className="icon-spacing" />
            Review your settings and initialize the AI bot flow
          </span>
        ) : (
          <div className="ai-running-container">
            <Technology />
            <span>Your AI is now running and processing the data you provided.</span>
          </div>
        )}
      </div>

      <div className="card-container">
        <div className="card-wrapper">
          <Card title="">
            <div className="card-content">
              <TickAfter className="icon-spacing" />
              <div className="card-content-title">URL</div>
            </div>
            <p>{"www.deskala.com"}</p>
          </Card>
        </div>
        <div>{""}</div>
      </div>

      <div className="card-container">
        <div className="card-wrapper">
          <Card title="">
            <div>
              <div className="card-content">
                <TickAfter className="icon-spacing" />
                <div className="card-content-title">Company Sector</div>
              </div>
              <p>{registrationForm?.companySector}</p>
            </div>

            <div>
              <div className="card-content">
                <TickAfter className="icon-spacing" />
                <div className="card-content-title">AI Features</div>
              </div>
              <p>{registrationForm?.aiFeature}</p>
            </div>

            <div>
              <div className="card-content">
                <TickAfter className="icon-spacing" />
                <div className="card-content-title">Response Length</div>
              </div>
              <p>{"Medium"}</p>
            </div>
          </Card>
        </div>
        <div>{""}</div>
      </div>
    </div>
  );
};

export default StartFlow;
